import { c as _c } from "react/compiler-runtime";
import { HeadMeta } from '@/components/Molecules/HeadMeta/HeadMeta';
import { EmptyNavigation } from '@/components/Organisms/Navigation/EmptyNavigation';
import type { FCh } from 'react-fc';
import styled from 'styled-components';
export const ViewArea = styled.div`
    height: calc(100vh - var(--size-masthead-height));
    display: flex;
    > * {
        align-self: center;
    }
`;
export const ErrorPageTemplate: FCh<{
  title: string;
}> = t0 => {
  const $ = _c(8);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <HeadMeta title={title} />;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <EmptyNavigation />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <ViewArea>{children}</ViewArea>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};